<template>
    <svg viewBox="0 0 362.68 362.68">
        <circle style="fill:#005DE1;" cx="85.8" cy="181.34" r="85.8" />
        <circle style="fill:#FF007E;" cx="276.88" cy="181.34" r="85.8" />
    </svg>
</template>

<script>
export default {
    name: 'Flickr'
}
</script>
